function HasClass( el, cls )
{
    var current = el.getAttribute( "class" );
    return ( ( current != undefined ) && ( current.indexOf( cls ) != -1 ) );
}

function AddClass( el, cls )
{
    if ( el )
    {
        var current = el.getAttribute( "class" );
        if ( ( current == undefined ) || ( current.indexOf( cls ) == -1 ) )
        {
            current += " " + cls;
            el.setAttribute( "class", current );
        }
    }
}
function RemoveClass( el, cls )
{
    if ( el )
    {
        var current = el.getAttribute( "class" );
        if ( current )
        {
            current = current.replace( cls, ' ' );
            el.setAttribute( "class", current );
        }
    }
}
function SearchParentsFor( start, cls, top )
{
    var result;

    var parent = start.parentNode;
    if ( ( parent ) && (  parent.getAttribute ) )
    {
        var pcls = parent.getAttribute( "class" );
        if ( pcls )
        {
            var pclsArray = pcls.split( " " );
            for ( var i = 0; i < pclsArray.length; i++ )
            {
                if ( pclsArray[ i ] == cls )
                {
                    result = parent;
                    break;
                }
            }
        }

        if ( ( !result ) && ( ( !top ) || ( parent != top ) ) )
        {
            result = SearchParentsFor( parent, cls, top );
        }
    }

    return ( result );
}

function productQty( element )
{
    var parent      = SearchParentsFor( element, "lightning_qty_container" );
    var input       = parent.querySelector( "input" );
    var row         = SearchParentsFor( element, "cart__row" );

    var lineItem    = row.dataset.cartItemIndex;
    var itemKey     = row.dataset.cartItemKey;
    var variant     = itemKey.split( ":" )[ 0 ];
    var price       = row.dataset.cartItemPrice;
    
    var itemInventoryPolicy     = row.getAttribute( "data-inventory-policy" );
    var itemInventoryQuantity   = row.getAttribute( "data-inventoy" );

    if( element.dataset.type == "add" )
    {
        if( ( itemInventoryPolicy == "continue" ) || ( itemInventoryPolicy == "deny" && Number( input.value ) < Number( itemInventoryQuantity ) ) )
        {
            input.value = Number( input.value ) + 1;
        }
    }
    else
    {
        if( input.value > 0 )
        {
            input.value = input.value - 1;
        }
    }
    if( input.value == 0 )
    {
        removeProduct( lineItem );
    }
    else
    {
        $('.cartPageData .product_qty_adjust').addClass('disable');
        $('.cartPageData .cartCheckout').addClass('disable');
        UpdateProductQty( variant, lineItem, input.value, price, row, element.dataset.type );
    }
}

function UpdateProductQty( variant, lineItem, qty, price, row, direction )
{
    var xhr     = new XMLHttpRequest( );
    xhr.onreadystatechange = function( )
    {
        if ( xhr.readyState == 4 )
        {
            if ( xhr.status == 200 )
            {
                // AddNewVariant( qty, newVariant );
                console.log( "updated qty successful" + JSON.stringify( xhr ) );
                updateItemTotal( row, price, qty, direction );
            }
            else
            {
                console.log( "updating qty failed" + xhr.responseText );
            }
        }
    };

    xhr.open( "POST", "/cart/change.js", true );
    xhr.setRequestHeader( "Content-Type", "application/json" );
    xhr.send( JSON.stringify( { "id" : variant, "quantity" : qty } ) );
    setTimeout(function()
    {
        $('.cartPageData .product_qty_adjust').removeClass('disable');
        $('.cartPageData .cartCheckout').removeClass('disable');
    }, 1000);
}

function updateItemTotal( row, price, qty, direction )
{
    var itemTotalContainer          = row.querySelector( ".cart_item_total" );
    var currencySymbol              = row.dataset.cartCurrency;
    var newItemTotal                = ( ( Number( price ) * Number( qty ) ) / 100 );
    itemTotalContainer.innerHTML    = currencySymbol + newItemTotal.toFixed( 2 ); 
    itemTotalContainer.setAttribute( "data-cart-item-total", ( ( Number( price ) * Number( qty ) ) ) );
    updateCartTotal( );
}

function updateCartTotal(  )
{
    var rows                = document.querySelectorAll( ".item_cart_row" );
    var total               = 0;
    var cartTotalContainer  = document.querySelector( ".cart-subtotal__price" ); 
    var currencyISO         = cartTotalContainer.dataset.cartCurrencyIso;
    var currencySym         = cartTotalContainer.dataset.cartCurrency;

    for( var i = 0; i < rows.length; i++ )
    {
        var row                 = rows[ i ];
        var itemTotalContainer  = row.querySelector( ".cart_item_total" );
        var itemTotal           = Number( itemTotalContainer.dataset.cartItemTotal );
        total                   = total + itemTotal;
    }
    
    cartTotalContainer.innerHTML = currencySym + ( total / 100 ).toFixed( 2 ) + " " + currencyISO;

}

function updateProductVariant( select )
{
    var parent          = SearchParentsFor( select, "cart__row" );
    var qtyContainer    = parent.querySelector( ".product_qty_input" );
    var qty             = qtyContainer.value;
    var options         = select.options;
    var lineItem        = parent.dataset.cartItemIndex;
    var newVariant;

    for( var i = 0; i < options.length; i++ )
    {
        var option = options[ i ];
        option.removeAttribute( "selected", "selected" );
        if( select.selectedIndex == i )
        {
            option.setAttribute( "selected", "selected" );
            newVariant = option.value;
        }
    }

    removeProduct( lineItem, qty, newVariant, true )
}

function addProduct( qty, newVariant )
{
    var xhr     = new XMLHttpRequest( );
    xhr.onreadystatechange = function( )
    {
        if ( xhr.readyState == 4 )
        {
            if ( xhr.status == 200 )
            {
                window.location.reload( );
            }
            else
            {
                console.log( "add new variant faild" + xhr.responseText );
            }
        }
    };

    xhr.open( "POST", "/cart/add.js", true );
    xhr.setRequestHeader( "Content-Type", "application/json" );
    xhr.send( JSON.stringify( { "quantity" : qty, "id" : newVariant } ) );

}

function removeProduct( lineItem, qty, newVariant, add )
{
    var xhr     = new XMLHttpRequest( );
    xhr.onreadystatechange = function( )
    {
        if ( xhr.readyState == 4 )
        {
            if ( xhr.status == 200 )
            {
                if( add )
                {
                    addProduct( qty, newVariant );
                } 
                else
                {
                    window.location.reload( );
                }
            }
            else
            {
                console.log( "updating qty failed" + xhr.responseText );
            }
        }
    };

    xhr.open( "POST", "/cart/change.js", true );
    xhr.setRequestHeader( "Content-Type", "application/json" );
    xhr.send( JSON.stringify( { "line" : lineItem, "quantity" : 0 } ) );    
}

function toggleActiveClass( element )
{
    var parent = SearchParentsFor( element, "collection_select_container" );
    var error  = parent.querySelector( ".option-err-msg" );
    if( error )
    {
        error.remove();
    }
    var variants = parent.querySelectorAll( ".variant-type" );

    for( var i = 0; i < variants.length; i++ )
    {
        var variant = variants[ i ];
        variant.classList.remove( "active" );
    }

    if( !element.classList.contains( "active" ) )
    {
        element.classList.add( "active" );
    }
    else
    {
        element.classList.remove( "active" );
    }
}

function handleProductAdded( element )
{
    // var parent      = SearchParentsFor( element, "collection_product_container" ); 
    // var container   = parent.querySelector( ".collection_select_container" );
    // var error       = container.querySelector( ".collection-error" );
    var parent      = SearchParentsFor( element, "strength-and-cta" ); 
    var container   = parent.querySelector( ".collection_select_container" );
    var error       = parent.querySelector( ".collection-error" );
    var cartCount   = document.querySelector( "#CartCount" );
    var span        = cartCount.querySelector( "span" );
    if( error )
    {
        error.parentNode.removeChild( error );
    }

    if( !parent.querySelector( ".collection-added" ) )
    {
        var p           = document.createElement( "p" );
        p.innerHTML     = "Added";
        p.setAttribute( "style", "color: #b9a163; font-size: 17px; padding-top: 10px;" );
        p.classList.add( "collection-added" );
        container.appendChild( p );
        $.ajax({
            url: '/cart',
            type: 'GET',
            success: function (data) {
                var afteraddtocartHtml = $(data).find('.cartPageData form').html();
                // console.log(afteraddtocartHtml);
                $('.cartPageData form').html(afteraddtocartHtml);
                
            }
        });
    }    

    if( span.innerHTML == 0 )
    {
        span.innerHTML = Number( span.innerHTML ) + 1;
        cartCount.classList.remove( "hide" );
    }
    else
    {
        span.innerHTML = Number( span.innerHTML ) + 1;
    }
}

function handleBadRequest( response, element )
{
    // var parent      = SearchParentsFor( element, "collection_product_container" ); 
    // var container   = parent.querySelector( ".collection_select_container" );
    var parent      = SearchParentsFor( element, "strength-and-cta" ); 
    var container   = parent.querySelector( ".strength-container" );
    if( !container.querySelector( ".collection-error" ) )
    {
        var p           = document.createElement( "p" );
        var option      = parent.querySelector( ".visible-option" ).dataset.option;
        p.innerHTML     = "Please select a " + option;
        p.setAttribute( "style", "color: #b9a163; font-size: 17px" );
        p.classList.add( "collection-error" );
        container.appendChild( p );
    }
}

function stopPropagation( )
{
    window.event.preventDefault();
    window.event.stopPropagation();
}

function UpdateProduct( value, element )
{

    var newVariant      = value;
    var qty             = 1;

    var xhr     = new XMLHttpRequest( );
    xhr.onreadystatechange = function( )
    {
        if ( xhr.readyState == 4 )
        {
            if ( xhr.status == 200 )
            {
                // AddNewVariant( qty, newVariant );
                // console.log( "added" );
                handleProductAdded( element );
            }
            else
            {
                console.log( "adding variant failed" + xhr.responseText );
                handleBadRequest( JSON.parse( xhr.response ), element );
            }
        }
    };

    xhr.open( "POST", "/cart/add.js", true );
    xhr.setRequestHeader( "Content-Type", "application/json" );
    xhr.send( JSON.stringify( { "quantity" : qty, "id" : newVariant } ) );

}

function handleOptionErrMessage( element )
{
    var parent      = SearchParentsFor( element, "strength-and-cta" ); 
    var container   = parent.querySelector( ".strength-container" );
    var p           = document.createElement( "p" );
    p.innerHTML     = "Please select an option";
    p.setAttribute( "style", "color: #b9a163; font-size: 17px" );
    p.setAttribute( "class", "option-err-msg" );
    p.classList.add( "collection-error" );
    container.appendChild( p );
}

function updateChosenVariant( element )
{
    stopPropagation( );
    // var selectContainers        = document.querySelectorAll( ".cart--item" );
    // var parent                  = SearchParentsFor( element, "collection_product_container" );
    var productInfoContainer    = SearchParentsFor( element, "collection-product-info-container" );
    var select                 = productInfoContainer.querySelector( "select" );

    if( select )
    {
        var product = select.dataset.variant;
        if( product )
        {
            UpdateProduct( product, element );
        }
    }
    else
    {
        var variant = productInfoContainer.querySelector( ".collection_select_container .active" );
        if( !variant )
        {           
            handleOptionErrMessage( element )
        }
        else 
        {
            var product = variant.dataset.variant;
            if( product )
            {
                UpdateProduct( product, element );
            }
        }
    }
}

function closeCartPopup( element )
{
    var parent = SearchParentsFor( element, "promotion-offer-modal-wrapper");
    parent.classList.add( "hidden" );
}

function showCartOfferPopup()
{
    var popupMessage = document.getElementById( "promotion-offer-criteria");
    if( popupMessage )
    {
        var popupCriteria = popupMessage.dataset.criteria;
        var popupContainer = document.getElementById( "promotion-offer-modal" );
    
        console.log(popupMessage);
        console.log(popupCriteria);
        console.log(popupContainer);
        if( popupCriteria == "true" )
        {
            popupContainer.classList.remove( "hidden" );
        }
    }
}

window.addEventListener( "load", function()
{
    showCartOfferPopup();
} );